<template>
  <modal
    ref="integrationModal"
    template="neutral"
    ref-name="integrationModal"
    :icon-enabled="false"
    :close-button-enabled="true"
    class="integration-modal"
  >
    <button
      class="close-button btn-transparent"
      @click="closeIntegrationModal"
    >
      <md-icon>clear</md-icon>
    </button>
    <div class="integration-modal__tabs">
      <h3
        :class="{ active: activeTab === 'params' }"
        @click="setTab('params')"
      >
        Parâmetros do exame
      </h3>
      <h3
        :class="{ active: activeTab === 'result' }"
        @click="setTab('result')"
      >
        Linhas de Resultado
      </h3>
      <!-- <h3 @click="setTab('methods')" :class="{ active: activeTab === 'methods' }">Metodologia</h3> -->
    </div>
    <div
      v-if="!loading"
      class="integration-modal__content"
    >
      <template v-if="activeTab === 'params'">
        <div
          v-if="paramsList.mnemonic && paramsList.materials && paramsList.lastChange"
          class="integration-modal__data"
        >
          <div class="integration-modal__data--top">
            <div class="integration-modal__values integration-modal__values--full">
              <h5>Mnemônico e descrição do exame</h5>
              <div class="value">
                <span>
                  {{ paramsList.mnemonic + ' - ' + paramsList.name }}
                </span>
                <ButtonCopy
                  v-if="paramsList.mnemonic + ' - ' + paramsList.name"
                  :text-to-copy="paramsList.mnemonic + ' - ' + paramsList.name"
                />
              </div>
            </div>
            <template v-for="material in defaultMaterials">
              <div
                v-if="material.materialDefault"
                :key="`default-material-${material.code || material.name}`"
                class="integration-modal__values integration-modal__values--half"
              >
                <h5>Material padrão</h5>
                <div class="value">
                  <span>
                    {{ material.code + ' - ' + material.name }}
                  </span>
                  <ButtonCopy
                    v-if="material.name"
                    :text-to-copy="material.code + ' - ' + material.name"
                  />
                </div>
              </div>
            </template>
          </div>

          <div
            v-for="refValue in uniqueNewFormatReferenceValues"
            :key="`ref-value-${formatDate(refValue.dateUpdated)}-${refValue.methodology || ''}-${refValue.ntoDisplayText || ''}`"
            class="integration-modal__reference-wrapper"
          >
            <div class="integration-modal__reference-info">
              <div class="integration-modal__reference-item">
                <span class="integration-modal__reference-label">Metodologia:</span>
                <span class="integration-modal__reference-text">
                  {{ refValue.methodology }}
                </span>
                <ButtonCopy
                  v-if="refValue.methodology"
                  :text-to-copy="refValue.methodology"
                  style="height: 20px !important; width: 20px !important"
                />
              </div>
              <div
                class="integration-modal__reference-item"
                style="font-size: 12px !important; color: #7a7a7a !important"
              >
                <span class="integration-modal__reference-label">Execução:</span>
                <span class="integration-modal__reference-text">
                  {{ refValue.ntoDisplayText }}
                </span>
                <ButtonCopy
                  v-if="refValue.ntoDisplayText"
                  :text-to-copy="refValue.ntoDisplayText"
                  style="height: 20px !important; width: 20px !important"
                />
              </div>
            </div>

            <div
              class="integration-modal__values integration-modal__reference-date-wrapper"
            >
              <h5>Data da última alteração</h5>
              <div class="value">
                <span>{{ formatDate(refValue.dateUpdated) }}</span>
                <ButtonCopy
                  v-if="refValue.dateUpdated"
                  :text-to-copy="formatDate(refValue.dateUpdated)"
                />
              </div>
            </div>
          </div>

          <div class="integration-modal__values integration-modal__box-materials">
            <h5>Materiais possíveis</h5>
            <div class="integration-modal__values integration-modal__values--full">
              <div
                v-for="material in uniqueMaterials"
                :key="`possible-material-${material.code || material.name}`"
                class="value"
              >
                <span>
                  {{ material.code + ' - ' + material.name }}
                </span>
                <ButtonCopy
                  v-if="material.name"
                  position="left"
                  :text-to-copy="material.code + ' - ' + material.name"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="integration-modal__error-msg"
        >
          <img
            src="/static/images/icon-empty-cart.svg"
            alt="Esse exame não possui parâmetros do exame"
          />
          <p>
            Esse exame não possui
            <br />
            parâmetros do exame
          </p>
        </div>
      </template>
      <template v-if="activeTab === 'result'">
        <div
          v-if="filteredCriticisms.length > 0"
          class="integration-modal__table"
        >
          <div
            class="integration-modal__table-content integration-modal__table-content--fixed"
          >
            <h5 class="code">Código</h5>
            <h5 class="name">Nome</h5>
            <h5 class="line">Linha</h5>
            <h5 class="unit">Unidade</h5>
          </div>
          <div class="integration-modal__table-wrapper">
            <div
              v-for="(param, index) in filteredCriticisms"
              :key="`param-criticism-${index}-${param.idCriticism || index}`"
              class="integration-modal__table-content integration-modal__table-content--values"
            >
              <div class="code">
                <span>
                  {{ param.idCriticism }}
                </span>
                <ButtonCopy
                  v-if="param.idCriticism"
                  :text-to-copy="param.idCriticism"
                />
              </div>
              <div class="name">
                <span>
                  {{ param.name }}
                </span>
                <ButtonCopy
                  v-if="param.name"
                  :text-to-copy="param.name"
                />
              </div>
              <div class="line">
                <span>
                  {{ param.position }}
                </span>
                <ButtonCopy
                  v-if="param.position"
                  :text-to-copy="param.position"
                />
              </div>
              <div class="unit">
                <svg-loader
                  class="warning-alert__icon integration-modal__unit-icon"
                  src="/static/images/icon-warning.svg"
                />
              </div>
            </div>
          </div>
          <WarningAlert
            :alert-text="unitMeasureWarningText"
            class="integration-modal__unit-warning"
            item-name-in-storage="exam-guide-integration-result-unit-warning"
            icon="icon-warning.svg"
            variant="reference-value"
          />
        </div>
        <div
          v-else
          class="integration-modal__error-msg"
        >
          <img
            src="/static/images/icon-empty-cart.svg"
            alt="Esse exame não possui linhas de resultado"
          />
          <p>
            Esse exame não possui
            <br />
            linhas de resultado
          </p>
        </div>
      </template>
      <template v-if="activeTab === 'methods'">
        <div
          v-if="paramsList.examMethod"
          class="integration-modal__data integration-modal__data--methods"
        >
          <div class="integration-modal__values integration-modal__values--half">
            <h5>Código da metodologia</h5>
            <div class="value">
              <span>
                {{ paramsList.examCodeMethod }}
              </span>
              <ButtonCopy
                v-if="paramsList.examCodeMethod"
                :text-to-copy="paramsList.examCodeMethod"
              />
            </div>
          </div>
          <div class="integration-modal__values integration-modal__values--half">
            <h5>Metodologia</h5>
            <div class="value">
              <span>
                {{ paramsList.examMethod }}
              </span>
              <ButtonCopy
                v-if="paramsList.examMethod"
                :text-to-copy="paramsList.examMethod"
              />
            </div>
          </div>
        </div>
        <div
          v-else
          class="integration-modal__error-msg"
        >
          <img
            src="/static/images/icon-empty-cart.svg"
            alt="Esse exame não possui metodologia"
          />
          <p>
            Esse exame não possui
            <br />
            metodologia
          </p>
        </div>
      </template>
    </div>

    <!-- <button class="integration-modal__btn-export" @click="downloadExcel" v-if="!loading && paramsList">
      <svg-loader class="icon-download-modal" src="/static/images/site/icon-download.svg" />
      Exportar em Excel
    </button> -->
    <Spinner v-else />
  </modal>
</template>
<script>
import Spinner from '@/components/common/Spinner'
import ButtonCopy from '@/components/common/buttonComponent/ButtonCopy.vue'
import WarningAlert from '@/components/common/Alert.vue'
import examGuideService from '@/api/examGuide'
import Moment from 'moment'

export default {
  name: 'IntegrationModalParams',
  components: {
    Spinner,
    ButtonCopy,
    WarningAlert,
  },
  props: {
    newFormatReferenceValues: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    paramsList: [],
    msgError: false,
    activeTab: 'params',
    loading: false,
  }),
  computed: {
    mnemonic() {
      return this.$route.query.mnemonic
    },
    lastChange() {
      return Moment(this.paramsList.lastChange).format('DD/MM/YYYY')
    },
    uniqueMaterials() {
      if (!Array.isArray(this.paramsList.materials)) {
        return []
      }

      return this.getUniqueItems(this.paramsList.materials, material => {
        return [material.code, material.name].map(this.normalizeValue).join('|')
      })
    },
    defaultMaterials() {
      return this.uniqueMaterials.filter(material => material.materialDefault)
    },
    uniqueNewFormatReferenceValues() {
      return this.getUniqueItems(this.newFormatReferenceValues, refValue => {
        return this.formatDate(refValue.dateUpdated)
      })
    },
    unitMeasureWarningText() {
      return `
        A Unidade de Medida é definida dinamicamente. Para identificar a unidade aplicada à execução,
        consulte o NTO de Execução e a data da versão apresentada no arquivo de integração.
      `
    },
    filteredCriticisms() {
      if (!this.paramsList.criticisms || !Array.isArray(this.paramsList.criticisms)) {
        return []
      }

      const criticisms = this.paramsList.criticisms
        .filter(criticism => {
          const name = criticism.name && criticism.name.trim()
          return name && name !== '-'
        })
        .sort((a, b) => {
          const posA = parseInt(a.position) || 0
          const posB = parseInt(b.position) || 0
          return posA - posB
        })

      return this.getUniqueItems(criticisms, criticism => {
        return [criticism.idCriticism, criticism.name, criticism.position]
          .map(this.normalizeValue)
          .join('|')
      })
    },
  },
  methods: {
    normalizeValue(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
    },
    getUniqueItems(items, getKey) {
      const keys = new Set()

      return items.filter(item => {
        const key = getKey(item)
        if (!key || keys.has(key)) return false

        keys.add(key)
        return true
      })
    },
    formatDate(date) {
      if (!date) return 'N/A'
      const dateTime = Moment(date)
      return dateTime.format('DD/MM/YYYY') + ' às ' + dateTime.format('HH:mm:ss')
    },
    openIntegrationModal() {
      document.documentElement.style.overflow = 'hidden'
      this.loading = true

      examGuideService
        .getIntegrationParams(this.mnemonic)
        .then(response => {
          this.loading = false
          this.paramsList = response.data
        })
        .catch(err => {
          this.loading = false
          this.msgError = err.response.data.message
        })
      this.$refs.integrationModal.open()
    },
    closeIntegrationModal() {
      document.documentElement.style.overflow = ''
      this.$refs.integrationModal.close()
      this.msgError = false
      this.paramsList = []
      this.activeTab = 'params'
    },
    downloadExcel() {
      window.open(
        process.env.EXAM_GUIDE_URL +
          'exams/integration/parameter/mnemonic/' +
          this.mnemonic +
          '/xlsx'
      )
    },
    setTab(tab) {
      this.activeTab = tab
    },
  },
}
</script>
<style lang="scss">
.integration-modal {
  font-family: 'Exo 2', sans-serif !important;

  .md-dialog {
    min-width: 800px;
    width: 90%;
    max-width: 1000px;
    height: 620px;
    min-height: 620px;
  }

  .md-dialog-title {
    display: none;
  }

  .md-dialog-content {
    padding: 0;
    display: flex;
    flex-flow: column;

    > div:first-child {
      flex: 1;
      display: flex;
      flex-flow: column;
      overflow-y: auto;
    }
  }

  .close-button {
    z-index: 90;
    top: 15px;
    right: 24px;
  }

  .loader {
    width: 80px;
    height: 80px;
    margin: 50px auto 20px;
  }

  &__content {
    flex: 1;
    display: flex;
    flex-flow: column;
    overflow-y: auto;
  }

  &__table,
  &__data {
    margin-top: 24px;
    padding: 0 80px 50px;
    align-content: flex-start;
  }

  &__table {
    padding: 0 80px 0px;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;

    &-wrapper {
      overflow-y: scroll;
      flex: 1 1 100%;
    }
  }

  &__unit-warning {
    flex-shrink: 0;
    margin: 12px 0 0;
  }

  &__data {
    display: flex;
    margin-top: 12px;
    overflow-y: auto;

    &:not(.integration-modal__data--methods) {
      padding-bottom: 0;
      flex-direction: column;
    }

    &--top {
      display: flex;
      flex-wrap: wrap;
      margin-top: 12px;
    }
  }

  &__values {
    margin-top: -4px;
    flex-shrink: 1;
    width: 100%;

    &--full {
      flex: 1 1 100%;
    }

    &--half {
      flex: 1 1 50%;
      max-width: 50%;
    }

    h5 {
      color: #7f1a54;
      font-weight: 400;
      font-size: 12px;
      margin: 20px 4px 0;
    }

    .value {
      border-radius: 3px;
      background-color: #f5f5f5;
      padding: 0 8px;
      height: 40px;
      margin: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      span {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: width ease 0.3s;
      }

      &:hover {
        background-color: rgba(127, 26, 84, 0.08);
        overflow: inherit;

        span {
          width: calc(100% - 36px);
        }

        .btn-copy {
          opacity: 1;
        }
      }
    }
  }

  &__table-content {
    display: flex;
    margin: 0 -4px;

    &--values {
      margin-top: -4px;
      flex-shrink: 1;
      width: 100%;

      .name {
        font-weight: 600;
      }
    }

    & > h5 {
      color: #7f1a54;
      font-weight: 400;
      font-size: 12px;
      margin: 4px;
    }

    & > div {
      border-radius: 3px;
      background-color: #f5f5f5;
      padding: 0 8px;
      height: 40px;
      margin: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;

      span {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: width ease 0.3s;
      }

      &:hover {
        background-color: rgba(127, 26, 84, 0.08);
        overflow: inherit;

        span {
          width: calc(100% - 36px);
        }

        .btn-copy {
          opacity: 1;
        }
      }
    }

    .code {
      min-width: 90px;
    }

    .name {
      flex-grow: 1;
      min-width: 500px;
    }

    .unit {
      width: 100px;
      justify-content: center;

      .warning-alert__icon {
        margin: 0;
      }
    }

    .line {
      width: 60px;
    }
  }

  &__tabs {
    display: flex;
    justify-content: space-between;
    padding: 50px 80px 0;
    background: #f4f4f4;

    h3 {
      font-size: 16px;
      flex: 1 1;
      flex-grow: 1 !important;
      text-align: center;
      color: #7a7a7a;
      font-weight: 400;
      padding-bottom: 8px;
      cursor: pointer;

      &.active {
        font-weight: 600;
        color: #7f1a54;
        border-bottom: 2px solid #7f1a54;
      }
    }
  }

  &__btn-export {
    background-color: transparent;
    border: 2px solid #7f1a54;
    color: #7f1a54;
    text-transform: uppercase;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    width: 100%;
    margin-top: 15px;
    font-family: 'Exo 2', sans-serif !important;
    font-size: 12px;
    padding: 0 16px;
    font-weight: 600;
    transition: all 0.4s ease-in-out;
    max-width: 180px;
    margin: 24px auto 32px;

    &:hover {
      background-color: #7f1a54;
      color: #fff;

      .md-icon {
        path {
          fill: #fff;
        }
      }
    }

    .md-icon {
      margin: 0 2px 0 0;

      svg {
        width: 20px;
      }

      path {
        transition: all 0.4s ease-in-out;
      }
    }
  }

  &__box-materials {
    width: 100%;
    display: flex;
    flex-direction: column;

    .integration-modal__values {
      margin-top: 0;
      padding-bottom: 15px;

      .value {
        overflow: hidden !important;
      }
    }
  }

  &__error-msg {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 100px;
    flex: 1;

    img {
      margin-bottom: 25px;
    }

    p {
      font-size: 23px;
      color: #818181;
      font-weight: 400;
      line-height: 27.65px;
      text-align: center;
    }
  }

  &__reference-wrapper {
    display: flex;
    margin-top: 12px;
    gap: 8px;
    min-width: 0;
  }

  &__reference-info {
    flex: 1;
    background-color: #f5f5f5;
    border-radius: 3px;
    padding: 0 12px;
    display: flex;
    flex-direction: column;
    gap: 0;
    min-width: 0;
    overflow: hidden;
  }

  &__reference-date-wrapper {
    flex-shrink: 0;
    width: auto;
    min-width: 220px;

    h5 {
      margin-top: 0;
    }
  }

  &__reference-item {
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    gap: 4px;
    position: relative;
    min-width: 0;
    overflow: hidden;

    &:hover {
      .btn-copy {
        opacity: 1;
      }
    }

    .btn-copy {
      opacity: 0;
      transition: opacity 0.3s ease;
      margin-left: auto;
      flex-shrink: 0;
    }
  }

  &__reference-label {
    color: #7f1a54;
    flex-shrink: 0;
  }

  &__reference-text {
    color: #303030;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    flex: 1;

    &--ntos {
      > span {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  &__reference-row {
    display: flex;
    flex-wrap: wrap;
    margin-top: 12px;
  }
}
</style>
